export default __webpack_public_path__ + "static/media/crossDisable.3f3f994e.svg";